import { InsuranceclaimsClass } from 'src/app/shared/models/insuranceclaims-class';
import { InsurancePolicyClass, InsurancePolicyReceipts } from 'src/app/shared/models/insurancesPolicy-class';
import {
  CommercialClass,
  CommercialsAreaLayoutResumeClass,
  CommercialTotalProductsClass,
  LayoutResumeHTMLClass,
  ResumeCustomerProductsClass,
} from './../models/commercial-class';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CustomerClass } from '../models/customer-class';
import { HttpclienterrorService } from '../interceptor/httpclienterror.service';
import { FilesClass } from '../models/uploads-class';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommercialService {
  HttpClienterrorMsg: string;

  constructor(
    private http: HttpClient,
    public httpclienterrorService: HttpclienterrorService,
  ) {}

  CommercialAreaGetInsurancePolicyID(
    idCommercial: number,
    idCustomer: number,
    idInsurancePolicy: number,
  ): Observable<InsurancePolicyClass[]> {
    return this.http
      .post<
        InsurancePolicyClass[]
      >(environment.URL + `/commercial/CommercialAreaGetInsurancePolicyID`, { idCommercial: idCommercial || 0, idCustomer, idInsurancePolicy })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetInsurancePolicyFiles(idCommercial: number, idInsurancePolicy: number): Observable<FilesClass[]> {
    return this.http
      .post<
        FilesClass[]
      >(environment.URL + `/commercial/CommercialAreaGetInsurancePolicyFiles`, { idCommercial: idCommercial || 0, idInsurancePolicy })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetInsurancePolicyReceipts(
    idCommercial: number,
    idCustomer: number,
    idInsurancePolicy: number,
  ): Observable<InsurancePolicyReceipts[]> {
    return this.http
      .post<
        InsurancePolicyReceipts[]
      >(environment.URL + `/commercial/CommercialAreaGetInsurancePolicyReceipts`, { idCommercial: idCommercial || 0, idCustomer, idInsurancePolicy })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetInsuranceClaims(idCommercial: number, idCustomer: number): Observable<InsuranceclaimsClass[]> {
    return this.http
      .post<
        InsuranceclaimsClass[]
      >(environment.URL + `/commercial/CommercialAreaGetInsuranceClaims`, { idCommercial: idCommercial || 0, idCustomer })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetInsuranceClaimsId(
    idCommercial: number,
    idCustomer: number,
    idInsuranceClaims: number,
  ): Observable<InsuranceclaimsClass[]> {
    return this.http
      .post<
        InsuranceclaimsClass[]
      >(environment.URL + `/commercial/CommercialAreaGetInsuranceClaimsId`, { idCommercial: idCommercial || 0, idCustomer, idInsuranceClaims })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetInsurancePolicy(idCommercial: number, idCustomer: number): Observable<InsurancePolicyClass[]> {
    return this.http
      .post<
        InsurancePolicyClass[]
      >(environment.URL + `/commercial/CommercialAreaGetInsurancePolicy`, { idCommercial: idCommercial || 0, idCustomer })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetInsuranceClaimsByidInsurancePolicy(
    idCommercial: number,
    idCustomer: number,
    idInsurancePolicy: number,
  ): Observable<InsuranceclaimsClass[]> {
    return this.http
      .post<
        InsuranceclaimsClass[]
      >(environment.URL + `/commercial/CommercialAreaGetInsuranceClaimsByidInsurancePolicy`, { idCommercial: idCommercial || 0, idCustomer, idInsurancePolicy })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetCommercialResumeGlobalCompanies(idCommercial: number): Observable<ResumeCustomerProductsClass[]> {
    return this.http
      .post<
        ResumeCustomerProductsClass[]
      >(environment.URL + `/commercial/CommercialAreaGetCommercialResumeGlobalCompanies`, { idCommercial: idCommercial || 0 })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetCommercialResumeGlobalProducts(idCommercial: number): Observable<ResumeCustomerProductsClass[]> {
    return this.http
      .post<
        ResumeCustomerProductsClass[]
      >(environment.URL + `/commercial/CommercialAreaGetCommercialResumeGlobalProducts`, { idCommercial: idCommercial || 0 })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetCommercialResumeProducts(
    idCommercial: number,
    idCustomer: number,
  ): Observable<ResumeCustomerProductsClass[]> {
    return this.http
      .post<
        ResumeCustomerProductsClass[]
      >(environment.URL + `/commercial/CommercialAreaGetCommercialResumeProducts`, { idCommercial: idCommercial || 0, idCustomer })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetInsuranceClaimsStatusTypes(
    idCommercial: number,
    idCustomer: number,
    idInsuranceClaimsStatusTypes: number,
  ): Observable<InsuranceclaimsClass[]> {
    return this.http
      .post<
        InsuranceclaimsClass[]
      >(environment.URL + `/commercial/CommercialAreaGetInsuranceClaimsStatusTypes`, { idCommercial: idCommercial || 0, idCustomer, idInsuranceClaimsStatusTypes })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetInsurancePolicyStatusTypes(
    idCommercial: number,
    idCustomer: number,
    idInsurancePolicyStatusTypes: number,
  ): Observable<InsurancePolicyClass[]> {
    return this.http
      .post<
        InsurancePolicyClass[]
      >(environment.URL + `/commercial/CommercialAreaGetInsurancePolicyStatusTypes`, { idCommercial: idCommercial || 0, idCustomer, idInsurancePolicyStatusTypes })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetCommercialResumeHTML(
    idCommercial: number,
    idCustomer: number,
    idCommercialAreaLayoutResume: number,
  ): Observable<LayoutResumeHTMLClass[]> {
    return this.http
      .post<
        LayoutResumeHTMLClass[]
      >(environment.URL + `/commercial/CommercialAreaGetCommercialResumeHTML`, { idCommercial: idCommercial || 0, idCustomer, idCommercialAreaLayoutResume })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetMyCustomers(idCommercial: number): Observable<CustomerClass[]> {
    return this.http
      .post<
        CustomerClass[]
      >(environment.URL + `/commercial/CommercialAreaGetMyCustomers`, { idCommercial: idCommercial || 0 })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  /**
   * Pesquisa normal de clientes (campos principais)
   */
  SearchCustomers(idCommercial: number, texto: string): Observable<CustomerClass[]> {
    const searchText = texto || null;
    return this.http
      .post<
        CustomerClass[]
      >(`${environment.URL}/commercial/SearchCustomers`, { idCommercial: idCommercial || 0, texto: searchText })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  /**
   * Pesquisa avançada de clientes (TODOS os campos relacionados)
   * Inclui: CustomerShipToAddress, CustomerContact, emails completos, etc
   */
  SearchCustomersAdvanced(idCommercial: number, texto: string): Observable<CustomerClass[]> {
    const searchText = texto || null;
    return this.http
      .post<
        CustomerClass[]
      >(`${environment.URL}/commercial/SearchCustomersAdvanced`, { idCommercial, texto: searchText })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetCommercialResume(LineTop: number): Observable<CommercialsAreaLayoutResumeClass[]> {
    return this.http
      .post<
        CommercialsAreaLayoutResumeClass[]
      >(environment.URL + `/commercial/CommercialAreaGetCommercialResume`, { LineTop })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetAreaLayoutResumeHTML(
    idCommercial: number,
    idCommercialAreaLayoutResume: number,
  ): Observable<LayoutResumeHTMLClass[]> {
    return this.http
      .post<
        LayoutResumeHTMLClass[]
      >(environment.URL + `/commercial/CommercialAreaGetAreaLayoutResumeHTML`, { idCommercial, idCommercialAreaLayoutResume })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetAreaLayoutResume(LineTop: number): Observable<CommercialsAreaLayoutResumeClass[]> {
    return this.http
      .post<
        CommercialsAreaLayoutResumeClass[]
      >(environment.URL + `/commercial/CommercialAreaGetAreaLayoutResume`, { LineTop })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCommercialsUser(idUser: number): Observable<CommercialClass[]> {
    return this.http
      .post<CommercialClass[]>(environment.URL + `/commercial/ClientAreaGetCommercialsUser`, { idUser })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCommercials(idCommercial: number): Observable<CommercialClass[]> {
    return this.http
      .post<CommercialClass[]>(environment.URL + `/commercial/ClientAreaGetCommercials`, { idCommercial })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetCommercialAll(): Observable<CommercialClass[]> {
    return this.http.get<CommercialClass[]>(environment.URL + `/commercial/ManagementGetCommercialAll`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  CommercialAreaTotalProductsPerCommercial(idUser: number): Observable<CommercialTotalProductsClass[]> {
    return this.http
      .post<
        CommercialTotalProductsClass[]
      >(environment.URL + `/commercial/CommercialAreaTotalProductsPerCommercial`, { idUser })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }
}
